import { render, staticRenderFns } from "./TabletHistoryUI.vue?vue&type=template&id=dfa268c6&scoped=true&"
import script from "./TabletHistoryUI.vue?vue&type=script&lang=js&"
export * from "./TabletHistoryUI.vue?vue&type=script&lang=js&"
import style0 from "./TabletHistoryUI.vue?vue&type=style&index=0&id=dfa268c6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa268c6",
  null
  
)

export default component.exports